module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-red-699a84566d1c19208ef7de9514caa39a.svg";